import {Module} from 'vuex';
import {mutations} from './mutations';
import {StoreState} from '@/brief-hub/store/state/StoreState';
import {ProductTourState} from '@/brief-hub/store/modules/product-tour/types';

export const state: ProductTourState = {
    myProjects: false,
    projectView: false,
};

export const productTour: Module<ProductTourState, StoreState> = {
    state,
    mutations,
};
